import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  ..alusta poodlemist siit

  <span style="color:#85c1dc;">**FI:**</span>
  ..aloita ostokset tästä

  <span style="color:#85c1dc;">**RU:**</span>
  ..начни здесь
*/
/* @__NO_SIDE_EFFECTS__ */
const m787 = msg(
  mf`..alusta poodlemist siit`,
  mf`..aloita ostokset tästä`,
  mf`..начни здесь`,
)

export { m787 as 'w.basket.empty.button.text' }